<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="language === 'HU'" key="about-hu" class="d-flex">
        <p class="font__futura-pt-bold">THE PROCESS...</p>
      </div>

      <div v-if="language === 'EN'" key="about-en">
        <p class="font__futura-pt-bold">VIDEO</p>

          <iframe src="https://player.vimeo.com/video/829988221?h=7a2d5e6599"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          <div class="video-wrapper">
              <div class="d-flex">
                  <p class="client">Client:</p>
                  <p class="client__title">MG</p>
              </div>
              <div class="d-flex">
                  <p class="prod">Prod.:</p>
                  <p class="prod__title">REPUBLIC GROUP</p>
              </div>
              <div class="d-flex">
                  <p class="music">Music:</p>
                  <p class="music__title">ZOMBLAZE</p>
              </div>

          </div>
        <iframe src="https://player.vimeo.com/video/648495785?h=7a2d5e6599"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          <div class="video-wrapper">
            <div class="d-flex">
              <p class="client">Client:</p>
              <p class="client__title">SERENE UNDERWEAR</p>
            </div>
            <div class="d-flex">
              <p class="prod">Prod.:</p>
              <p class="prod__title">RADBARBRAVES</p>
            </div>
            <div class="d-flex">
              <p class="music">Music:</p>
              <p class="music__title">PLANETMALCOLM</p>
            </div>

          </div>


<!--        <iframe src="https://player.vimeo.com/video/672288936?h=1270164cf5" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>-->
<!--        <div class="video-wrapper">-->
<!--          <div class="d-flex">-->
<!--            <p class="client">Client:</p>-->
<!--            <p class="client__title">KIFÜ</p>-->
<!--          </div>-->
<!--          <div class="d-flex">-->
<!--            <p class="prod">Prod.:</p>-->
<!--            <p class="prod__title">ADMIRAL FILM</p>-->
<!--          </div>-->
<!--          <div class="d-flex">-->
<!--            <p class="prod">Director.:</p>-->
<!--            <p class="prod__title">KICKASS FACTORY</p>-->
<!--          </div>-->
<!--          <div class="d-flex">-->
<!--            <p class="music">Music:</p>-->
<!--            <p class="music__title">ZOMBLAZE</p>-->
<!--          </div>-->
<!--        </div>-->
        <iframe src="https://player.vimeo.com/video/648539755?h=a365c84166" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          <div class="video-wrapper">
            <div class="d-flex">
            <p class="client">Client:</p>
            <p class="client__title">LIBERTY BANK GEORGIA</p>
            </div>
            <div class="d-flex">
            <p class="prod">Prod.:</p>
            <p class="prod__title">LEAVINGSTONE</p>
            </div>
            <div class="d-flex">
            <p class="music">Music:</p>
            <p class="music__title">ZOMBLAZE</p>
            </div>
          </div>

          <iframe src="https://player.vimeo.com/video/648500795?h=bf752e518c" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          <div class="video-wrapper">
              <div class="d-flex">
                  <p class="client">Client:</p>
                  <p class="client__title">GENERAL ELECTRIC</p>
              </div>
              <div class="d-flex">
                  <p class="prod">Prod.:</p>
                  <p class="prod__title">DERENGO</p>
              </div>
              <div class="d-flex">
                  <p class="music">Music:</p>
                  <p class="music__title">ZOMBLAZE</p>
              </div>
          </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MobileVideo",
  computed: {
    language: function () {
      return this.$store.getters.language;
    }
  },
}
</script>

<style scoped>
  .video-wrapper{
    margin-left: 5px;
  }
  .d-flex{
    margin-bottom: 0px;
  }
  .d-flex p{
    margin-bottom: 5px;
  }
  .video-wrapper .client{
    font-family:  futura-book-std, Serif;
    font-size: 9pt;
    letter-spacing: 1pt;
    margin-right: 4px;
  }

  .video-wrapper .client__title{
    font-family: futura-std-heavy, Serif;
    font-size: 9pt;
    letter-spacing: 0.5pt;
    margin-right: 5px;
  }

  .video-wrapper .prod{
    font-family:  futura-book-std, Serif;
    font-size: 9pt;
    letter-spacing: 1pt;
    margin-right: 4px;
  }

  .video-wrapper .prod__title{
    font-size: 9pt;
    letter-spacing: 0.5pt;
    font-family: futura-std-heavy, Serif;
    margin-right: 4px;
  }
  .video-wrapper .music{
    font-family:  futura-book-std, Serif;
    font-size: 9pt;
    letter-spacing: 1pt;
    margin-right: 4px;
  }

  .video-wrapper .music__title{
    font-size: 9pt;
    letter-spacing: 0.5pt;
    font-family: futura-std-heavy, Serif;
  }
iframe{
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  margin-bottom: 5px;
}
.font__futura-std-heavy{
  line-height: 18pt;
  letter-spacing: 1px;
  color: var(--asan-dark-grey)
}
.font__futura-book-std{
  letter-spacing: 1px;
  line-height: 18pt;
  color: var(--asan-dark-grey)
}
.font__futura-pt-bold{
  font-size: 18pt;
  letter-spacing: 2px;
}
img{
  width: 90vw;
}
</style>